import { REQUEST_ALL_LOGS_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { logs: [],  errors: null };

export default function logsManager(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_ALL_LOGS_SUCCESS:
      return { ...state, 
        numOfLogs: action.payload.data.num_rows,
        logs: action.payload.data.response_error_list,
        errors: null 
      };
      default:
      return state;
  }
}
